import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import "rxjs/add/operator/takeWhile";
import "rxjs/add/operator/share";
  import * as _ from "lodash";

/**
 * Subscription example:
 * subscription: any;
 * this.subscription = this.bindComponent.subscribe(BindComponentService.OBSERVABLE_ATTRIB,
 *   value => {
 *     this.attrib_receive_value = value;
 *   }
 * );
 *
 * @author Wesley Mascarenhas
 * @version $Id: bind.component.service.ts 91275 2018-05-15 20:41:25Z eduardo.s.neto $
 */
@Injectable()
export class BindComponentService {

  public static readonly REPORT_TYPE_CHANGE: string = 'REPORT_TYPE_CHANGE';
  public static readonly FILTER_REPORT_OPERATION: string = 'FILTER_REPORT_OPERATION';
  public static readonly FILTER_CONSUMPTION: string = 'FILTER_CONSUMPTION';
  public static readonly FILTER_ADMINISTRATION: string = 'FILTER_ADMINISTRATION';
  public static readonly FILTER_BLOCK: string = 'FILTER_BLOCK';
  public static readonly FILTER_SYNC: string = 'FILTER_SYNC';
  public static readonly FILTER_ACTIVE_TAB: string = 'FILTER_ACTIVE_TAB'; // ALTERADO
  public static readonly OPEN_SCREEN_BLOC_VOICE: string = 'OPEN_SCREEN_BLOC_VOICE';
  public static readonly OPEN_SCREEN_BLOC_GROUP_VOICE: string = 'OPEN_SCREEN_BLOC_GROUP_VOICE';
  public static readonly BLOCK_VOICE_DATA_PACK_LINE: string = 'BLOCK_VOICE_DATA_PACK_LINE';
  public static readonly OPEN_MODAL_LOADING: string = 'OPEN_MODAL_LOADING';
  public static readonly LIST_ACOUNT_BLOC_VOICE: string = 'LIST_ACOUNT_BLOC_VOICE';
  public static readonly LIST_CONFIG_BLOC_VOICE: string = 'LIST_CONFIG_BLOC_VOICE';
  public static readonly LOADING_VOICE_CONSUMPTION: string = 'LOADING_VOICE_CONSUMPTION';
  public static readonly LOADING_DATA_CONSUMPTION: string = 'LOADING_DATA_CONSUMPTION';
  public static readonly LOADING_DATA_CONSUMPTION_5G: string = 'LOADING_DATA_CONSUMPTION_5G';
  public static readonly LOADING_DATA_CONSUMPTION_5G_LAYOUT_ONLY: string = 'LOADING_DATA_CONSUMPTION_5G_LAYOUT_ONLY';
  public static readonly FRANCHISE_AVAILABLE_DATA_CONSUMPTION: string = 'FRANCHISE_AVAILABLE_DATA_CONSUMPTION';
  public static readonly FRANCHISE_AVAILABLE_DATA_CONSUMPTION_5G: string = 'FRANCHISE_AVAILABLE_DATA_CONSUMPTION_5G';
  public static readonly MANAGERLIST_AVAILABLE_DATA_CONSUMPTION: string = 'MANAGERLIST_AVAILABLE_DATA_CONSUMPTION';
  public static readonly FRANCHISE_AVAILABLE_VOICE_CONSUMPTION: string = 'FRANCHISE_AVAILABLE_VOICE_CONSUMPTION';
  public static readonly MANAGERLIST_AVAILABLE_VOICE_CONSUMPTION: string = 'MANAGERLIST_AVAILABLE_VOICE_CONSUMPTION';
  public static readonly IS_VOICE_CONSUMPTION: string = 'IS_VOICE_CONSUMPTION';
  public static readonly LOAD_VIEW_BLOCK_VOICE: string = 'LOAD_VIEW_BLOCK_VOICE';
  public static readonly LOAD_VIEW_VIVO_SYNC: string = 'LOAD_VIEW_VIVO_SYNC';
  public static readonly LOADING_VOICE_CONSUMPTION_FILTER: string = 'LOADING_VOICE_CONSUMPTION_FILTER';
  public static readonly IS_LOGIN_SUCESS: string = 'IS_LOGIN_SUCESS';
  public static readonly TOTAL_GROUPS: string = 'TOTAL_GROUPS';
  public static readonly ABBREVIATED_DIALING: string = 'ABBREVIATED_DIALING';
  public static readonly VALUE_SERVICE_VOICE: string = 'VALUE_SERVICE_VOICE';
  public static readonly HAS_PACKAGE_HIRE_FLAG: string = 'HAS_PACKAGE_HIRE_FLAG';
  public static readonly OPEN_LIBERATION_TAB: string = 'OPEN_LIBERATION_TAB';
  public static readonly VALUE_SERVICE_DATA: string = 'VALUE_SERVICE_DATA';
  public static readonly COUNT_PAGINATED_GROUP: string = 'COUNT_PAGINATED_GROUP';
  public static readonly BLOCK_VOICE_DATA_PACK_GROUP: string = 'BLOCK_VOICE_DATA_PACK_GROUP';





  private observableValues: Map<string, Observable<any>> = new Map<string, Observable<any>>();
  private observer: Map<string, Observer<any>>;
  private alive: boolean = true;

  constructor() {
  }

  public set(eventName: string, message: any) {
    if (this.observer) {
      if (this.observer[eventName]) {
        this.observer[eventName].next(message);
      }
    }
  }

  public subscribe(eventName: string, callback: Function) {
    this.createIfNeeded(eventName);
    this.observableValues[eventName].takeWhile(() => this.alive).subscribe(callback, (err) => {
    });
  }

  private createIfNeeded(eventName: string) {
    if (_.isUndefined(this.observableValues[eventName])) {
      this.observableValues[eventName] = new Observable(observer => {
        this.observer = _.isUndefined(this.observer) ? new Map<string, Observer<any>>() : this.observer;
        this.observer[eventName] = observer;
      }).share();
    }
  }

  ngOnDestroy() {
    this.alive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/bind.component.service.ts